<template>
  <div class="row">
    <b-card class="col-12" no-body>
      <div class="row">
        <div class="col-12 mb-3">
          <b-button variant="primary" v-if="permissao.c" @click="novoProjeto"
            >Novo projeto encerrado RN 316</b-button
          >
        </div>
        <div class="col-12 row">
          <filtro-empresas
            class="col-12 col-md-4"
            v-if="ehAdmin"
            @update="buscarDados()"
          />
        </div>
        <b-table
          @row-dblclicked="abrirProjeto"
          head-variant="dark"
          class="col-12"
          :items="tabela.dados"
          :fields="tabela.colunas"
        >
          <template #cell(acoes)="data">
            <div class="d-flex">
              <b-button variant="flat-primary" @click="abrirProjeto(data.item)">
                <i class="fas fa-edit"></i>
              </b-button>
            </div>
          </template>
        </b-table>
        <div class="col-12">
          <b-pagination
            v-model="tabela.paginaAtual"
            :total-rows="tabela.totalDeElementos"
            :per-page="tabela.itensPorPagina"
            @change="mudarPagina"
            align="center"
          ></b-pagination>
        </div>
      </div>
    </b-card>
  </div>
</template>
<script>
import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
export default {
  name: "ProjetoRN316Listagem",
  components: {},
  data: () => ({
    tabela: {
      colunas: [
        { key: "titulo", label: "Titulo" },
        { key: "codigo", label: "Cód. projeto" },
        { key: "anoInicio", label: "Ano de inicio" },
        { key: "anoFim", label: "Ano de termino" },
        { key: "acoes", label: "Ações" },
      ],
      dados: [],
      itensPorPagina: 10,
      paginaAtual: 0,
      totalDeElementos: 0,
    },
    empresas: [],
  }),
  methods: {
    novoProjeto: function () {
      this.$router.push({ name: "projeto-316-novo" });
    },
    abrirProjeto: function (item) {
      this.$router.push({ name: "projeto-316-detalhamento", params: { id: item.id } });
    },
    mudarPagina: function (pagina) {
      this.buscarDados(pagina - 1);
    },
    buscarDados: function (pagina = 0) {
      if (!this.empresaSelecionada) return;

      this.tabela.dados = [];
      this.tabela.totalDeElementos = 0;

      this.$store.dispatch(START_LOADING);

      MovimentacaoFinanceiraService.listarProjetosRN316(
        this.empresaSelecionada,
        this.tabela.itensPorPagina,
        pagina
      )
        .then((res) => {
          this.tabela.dados = res.data.data.itens;
          this.tabela.totalDeElementos = res.data.data.paginacao.totalDeElementos;
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
  },
  mounted: function () {
    this.buscarDados();
    this.$store.dispatch(DEFINIR_BREADCRUMB, [
      { titulo: "Projetos encerrados RN 316 (Regra nova)" },
    ]);
  },
  computed: {
    empresaSelecionada: function () {
      return this.$store.state.app.selectedCompanyObj.id;
    },
    ehAdmin() {
      return this.$store.getters["app/ehAdmin"];
    },
    permissao() {
      return this.$store.getters["app/retornaPermissao"]("ProjetosRn316");
    },
  },
};
</script>
<style lang=""></style>
